import { render, staticRenderFns } from "./extend-booking-candidate-dropdown.vue?vue&type=template&id=3bdeda3c&scoped=true&"
import script from "./extend-booking-candidate-dropdown.vue?vue&type=script&lang=js&"
export * from "./extend-booking-candidate-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./extend-booking-candidate-dropdown.vue?vue&type=style&index=0&id=3bdeda3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdeda3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
